// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {Chip, makeStyles} from '@material-ui/core';

type Props = {
  label: string,
  onDelete?: () => void,
  disabled?: boolean,
};

const useStyles = makeStyles(() => ({
  chip: {
    background: 'rgba(21, 140, 253, 0.1);',
    fontWeight: 600,
    '& span': {
      fontSize: '0.875rem',
      color: '#158CFD',
    },
    '& svg': {
      color: '#158CFD',
      '&:hover': {
        color: '#158CFD',
      },
    },
  },
}));

export default function ConversationLabel(props: Props) {
  const {label, onDelete, disabled} = props;
  const classes = useStyles();
  return (
    <Chip
      className={classes.chip}
      label={label}
      disabled={disabled}
      onDelete={onDelete ? onDelete : () => null}
    />
  );
}

ConversationLabel.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
};
